<script setup>
import { computed, useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
const src = computed(
  () =>
    `${globalConfig.value?.logoThumbnail || '/brand-assets/logo_thumbnail.svg'}?v=tilit2`
);
</script>

<template>
  <img v-bind="attrs" :src="src" alt="" />
</template>
